// Custom Dashboard 2 MUI Helper Functions
import pxToRem from "assets/theme/functions/pxToRem";

const cardContent = {
  styleOverrides: {
    root: {
      marginTop: 0,
      marginBottom: 0,
      padding: `${pxToRem(16)} ${pxToRem(28)} ${pxToRem(28)}`,
    },
  },
};

export default cardContent;
